import theme from "@/theme";
import { SVGProps } from "react";
const ImageSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
    <path
      fill={theme.palette.custom.mainBlue}
      d="M3 5.5A2.5 2.5 0 0 1 5.5 3h13A2.5 2.5 0 0 1 21 5.5v13a2.5 2.5 0 0 1-2.5 2.5h-13A2.5 2.5 0 0 1 3 18.5v-13ZM5.5 5a.5.5 0 0 0-.5.5v9.086l3-3 3 3 5-5 3 3V5.5a.5.5 0 0 0-.5-.5h-13ZM19 15.414l-3-3-5 5-3-3-3 3V18.5a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-3.086ZM9.75 7a1.75 1.75 0 1 0 .001 3.501A1.75 1.75 0 0 0 9.75 7Z"
    />
  </svg>
);
export default ImageSvg;
